import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  class: "col-auto position-fixed start-0",
  style: {"top":"80px","z-index":"1020","padding-left":"0"}
}
const _hoisted_4 = { class: "sidebar-card" }
const _hoisted_5 = { class: "list-group" }
const _hoisted_6 = ["onClick", "title"]
const _hoisted_7 = {
  key: 0,
  class: "chevron-container"
}
const _hoisted_8 = { class: "navigation-container" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "d-flex gap-2" }
const _hoisted_11 = { class: "d-flex gap-2" }
const _hoisted_12 = { class: "d-flex gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StepNavigationButtons = _resolveComponent("StepNavigationButtons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps.slice(0, 5), (step, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: step.key
              }, [
                _createElementVNode("button", {
                  class: _normalizeClass(["list-group-item", { active: _ctx.selectedStep === index }]),
                  onClick: ($event: any) => (_ctx.selectStep(index)),
                  style: {"cursor":"pointer","height":"70px","width":"70px"},
                  "data-bs-toggle": 'tooltip',
                  "data-bs-placement": 'right',
                  title: _ctx.$t('projectView.items.' + step.key)
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(step.icon)
                  }, null, 2),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("projectView.titleItems." + step.key)), 1)
                ], 10, _hoisted_6),
                (index < 4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[11] || (_cache[11] = [
                      _createElementVNode("i", { class: "bi bi-chevron-down" }, null, -1)
                    ])))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_StepNavigationButtons, {
              isFirstStep: _ctx.selectedStep === 0,
              isLastStep: _ctx.selectedStep === _ctx.steps.length - 1
            }, null, 8, ["isFirstStep", "isLastStep"])
          ]),
          _createElementVNode("button", {
            class: "list-group-item save-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showSaveModal = true)),
            style: {"cursor":"pointer","height":"40px","width":"100px"}
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("projectView.saveButton")), 1)
          ])
        ])
      ]),
      _cache[12] || (_cache[12] = _createElementVNode("div", {
        class: "col-auto d-none d-sm-block",
        style: {"width":"120px"}
      }, null, -1)),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentStepComponent), { "project-id": _ctx.projectId }, null, 8, ["project-id"]))
      ]),
      (_ctx.showSaveModal)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal-overlay",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showSaveModal = false))
          }, [
            _createElementVNode("div", {
              class: "modal-content",
              onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t("projectView.saveModal.title")), 1),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSaveModal = false)),
                  class: "btn btn-secondary"
                }, _toDisplayString(_ctx.$t("projectView.saveModal.cancel")), 1),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSaveProject && _ctx.handleSaveProject(...args))),
                  class: "btn btn-primary"
                }, _toDisplayString(_ctx.$t("projectView.saveModal.save")), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showErrorModal)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "modal-overlay",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showErrorModal = false))
          }, [
            _createElementVNode("div", {
              class: "modal-content error",
              onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t("projectView.validationModal.title")), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.errorMessage), 1),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showErrorModal = false)),
                  class: "btn"
                }, _toDisplayString(_ctx.$t("projectView.validationModal.ok")), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showSuccessModal)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "modal-overlay",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showSuccessModal = false))
          }, [
            _createElementVNode("div", {
              class: "modal-content success",
              onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t("projectView.successModal.title")), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("projectView.successModal.message")), 1),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showSuccessModal = false)),
                  class: "btn"
                }, _toDisplayString(_ctx.$t("projectView.successModal.ok")), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}